<shrd-uic-button-slider-arrow *ngIf="showButtonLeft" [direction]="direction.LEFT" [disableFade]="!buttonsUpdated">
  <shrd-uic-svg-icon
    icon="arrow-left"
    [preventRtlSwap]="true"
    title="Scroll left"
    class="icon text-primary"
    
  ></shrd-uic-svg-icon>
</shrd-uic-button-slider-arrow>

<div class="shrd-uic-tab-slider-scroller" #scroller>
  <div class="shrd-uic-tab-slider-scroller-content" #scrollerContent>
    <ng-content></ng-content>
  </div>
</div>

<shrd-uic-button-slider-arrow *ngIf="showButtonRight" [direction]="direction.RIGHT" [disableFade]="!buttonsUpdated">
  <shrd-uic-svg-icon
    icon="arrow-right"
    [preventRtlSwap]="true"
    title="Scroll right"
    class="icon text-primary"
    
  ></shrd-uic-svg-icon>
</shrd-uic-button-slider-arrow>
